import { Component, computed, inject, Input } from '@angular/core';
import { UserService } from '@sbd-doug-frontend/app/core/user/user.service';

@Component({
  selector: 'sbd-permission-handler',
  templateUrl: './permission-handler.component.html',
  standalone: false,
})
export class PermissionHandlerComponent {
  private _userService = inject(UserService);

  @Input() permissions: string[] = [];

  readonly hasPermission = computed(() => {
    const user = this._userService.currentAdmin();
    if (!user) {
      return false;
    }

    if (!this.permissions || this.permissions.length === 0) {
      return true;
    }

    const userPermissions = user.permissions || [];
    return this.permissions.every((p) => userPermissions.includes(p));
  });
}
